const blank = "https://www.booksie.com/files/profiles/22/mr-anonymous_230x230.png?0000-00-00%2000:00:00"

export const judges = [
    {
        name: "Patricia Kraft",
        position: "Professor of Computer Science",
        url: "https://cs.sdsu.edu/people/patricia-kraft/",
        photo: "https://cs.sdsu.edu/wp-content/uploads/2022/08/patty-kraft-512.jpg"
    },
    {
        name: "Manju Priya Muralidharan",
        position: "Professor of Computer Science",
        url: "https://cs.sdsu.edu/people/priya-manju-muralidharan/",
        photo: require("../images/officers/manju.jpg")
    },
    {
        name: "Dominic Dabish",
        position: "Professor of Computer Science",
        photo: "https://media.licdn.com/dms/image/v2/C4D22AQEPyBIrz-ellw/feedshare-shrink_800/feedshare-shrink_800/0/1663093973681?e=2147483647&v=beta&t=xsZZ4Musq24bsN9E_h5i_C5r-t8K62NJlqGqtLg6ke0",
    },
    {
        name: "JP Zendejas",
        position: "ACM Secretary",
        url: "https://jp.zendejas.org/",
        photo: require("../images/officers/jp.png")
    },
    {
        name: "Everett Richards",
        position: "ACM President",
        url: "https://everettrichards.com",
        photo: require("../images/officers/everett.jpg")
    },
    {
        name: "TBA",
        position: "To Be Announced",
        photo: blank
    },
    // {
    //     name: "TBA",
    //     position: "To Be Announced",
    //     photo: blank
    // },
    // {
    //     name: "TBA",
    //     position: "To Be Announced",
    //     photo: blank
    // },
]